import React from 'react';

export const Footer = () => {
  return (
    <>
      <footer>
        <div className="attribution">
          <p>
            Challenge by{' '}
            <a href="https://www.frontendmentor.io">Frontend Mentor</a>. Coded
            by{' '}
            <a href="https://github.com/faha1999/" title="faha1999">
              faha1999
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};
